module.exports = __webpack_public_path__ + "static/troy-parsons-lg-20f2e36bb3cc27d48c3e8ac3a94a777d.png";